import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from './utils/httpRequest';
import './css/Select.css';
import ModalDiv from "./ModalDiv";
import Config from "./core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "./atoms";
const apiUrl = Config.apiUrl;

const CustomerKeyLink = (props) => {
    const {onClose} = props;
    const [customerKeyLink, setCustomerKeyLink] = useState('');
    const inputCustomerKeyLink = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);

    async function makeQuery(query) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/customerKey';
            const response = await makeRequest(url, 'POST', {
                'Content-Type': 'application/json',
            });
            var urlObj = new URL(window.location.href);
            var root = urlObj.origin;
            setCustomerKeyLink(root + "/autocadastro/" + response.customerKey);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputCustomerKeyLink.current) {
            inputCustomerKeyLink.current.focus();
        }
        makeQuery('');
    }, []);

    const handleInputChange = async (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            await makeQuery(string);
        }
        setCustomerKeyLink(string);
    };


    const handleQuery = async (e) => {
        await makeQuery(customerKeyLink);
    };

    function copyToClipboard() {
        if (navigator.clipboard && window.isSecureContext) {
            // API moderna
            navigator.clipboard.writeText(customerKeyLink)
                .then(() => alert('Link copiado para a área de transferência.'))
                .catch(err => {
                    fallbackCopy(customerKeyLink);
                });
        } else {
            // Fallback para navegadores que não suportam navigator.clipboard
            fallbackCopy(customerKeyLink);
        }
    }

    function fallbackCopy(text) {
        try {
            const tempInput = document.createElement("input");
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            tempInput.setSelectionRange(0, 99999); // Para mobile
            document.execCommand("copy");
            document.body.removeChild(tempInput);
            alert("Link copiado para a área de transferência.");
        } catch (err) {
            alert("Não foi possível copiar o link.");
            console.error("Fallback error copying text: ", err);
        }
    }


    return (
        <div style={{width: '350px'}}>
            <h2>Link para cadastro de cliente:</h2>
            <input disabled={true} style={{width: '100%'}} ref={inputCustomerKeyLink} type="text"
                   value={customerKeyLink} onChange={handleInputChange}/>
            <div style={{marginTop: '5px', width: '100%', textAlign:"right"}}>
                <button style={{width: '100%'}} onClick={copyToClipboard}>Copiar para área de transferencia</button>
            </div>
        </div>
    );
};

export default CustomerKeyLink;
